import { makeAutoObservable } from "mobx";
import { IInstantExchangeSetting } from "../models/User";
import { IChangeable } from "./types";
import {IOption} from "../components/inputs/select-dropdown/select-dropdown";

interface IInstantExchangeSettingChanges extends Partial<IInstantExchangeSetting> {
};

class InstantExchangeStore implements IChangeable<IInstantExchangeSetting>{
    private _model: IInstantExchangeSetting = {} as IInstantExchangeSetting;
    private _changes: IInstantExchangeSettingChanges = {};

    constructor(instant_exchange_setting: IInstantExchangeSetting) {
        makeAutoObservable(this, {}, { autoBind: true });
        this.setModel(instant_exchange_setting);
    }

    private setModel(model: IInstantExchangeSetting) {
        this._model = model;
        this.discardChanges();
    }

    public get authPeriodOptions(): IOption[] {
        const options = [];
        for (let i = 7; i <= 28; i++){
            options.push({ label : i.toString(), value : Number(i) } as IOption);
        }

        return options;
    }

    public hasChanges() {
        return !!Object.keys(this._changes).length;
    }

    public getUpdatedModel(): IInstantExchangeSetting {
        return { ...this._model, ...this._changes };
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public get isActive(): boolean {
        return this._changes.is_active ?? this._model.is_active;
    }

    public get hasPaymentServiceIntegration(): boolean {
        return this._model?._additional_info?.has_payment_service_integrations ?? false;
    }

    public get hasVariantExchangeResolutionNamedInstantExchange(): boolean {
        return this._model?._additional_info?.has_variant_exchange_resolution_named_instant_exchange ?? false;
    }

    public get authPeriodInDays(): number {
        return this._changes.auth_period_in_days ?? this._model.auth_period_in_days;
    }

    public setAuthPeriodInDays(value: number) {
        // if it's the same value as model, we want to remove it from "_change" instead of setting it to be the same.
        if(this._model.auth_period_in_days.valueOf() === Number(value)){
            delete this._changes.auth_period_in_days;
        }
        else {
            this._changes.auth_period_in_days = Number(value);
        }
    }

    public setIsActive(value: boolean) {
        // if it's the same value as model, we want to remove it from "_change" instead of setting it to be the same.
        if(!!this._model.is_active.valueOf() === value){
            delete this._changes.is_active;
        }
        else {
            this._changes.is_active = value;
        }
    }
}

export default InstantExchangeStore;
